var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlyceGiftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alyce-gift-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alyce-gift-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5,23 L25,23 L25,15.5 L36.25,15.5 C36.9375,15.5 37.5,16.0625 37.5,16.75 L37.5,23 Z M35,34.25 C35,34.9375 34.4375,35.5 33.75,35.5 L25,35.5 L25,25.5 L35,25.5 L35,34.25 Z M17.5,35.5 L22.5,35.5 L22.5,15.5 L17.5,15.5 L17.5,35.5 Z M15,23 L2.5,23 L2.5,16.75 C2.5,16.0625 3.0625,15.5 3.75,15.5 L15,15.5 L15,23 Z M15,35.5 L6.25,35.5 C5.5625,35.5 5,34.9375 5,34.25 L5,25.5 L15,25.5 L15,35.5 Z M11.4453125,5.5 C13.2734375,5.5 14.5546875,6.2109375 18.421875,12.71875 L18.5859375,13 L11.4375,13 C9.609375,13 8.1171875,11.3203125 8.1171875,9.25 C8.125,7.1796875 9.6171875,5.5 11.4453125,5.5 Z M21.578125,12.71875 C25.4453125,6.2109375 26.734375,5.5 28.5546875,5.5 C30.3828125,5.5 31.875,7.1796875 31.875,9.25 C31.875,11.3203125 30.3828125,13 28.5546875,13 L21.40625,13 L21.578125,12.71875 Z M36.25,13 L33.1796875,13 C33.921875,11.953125 34.375,10.6640625 34.375,9.25 C34.375,5.8046875 31.765625,3 28.5546875,3 C25.25,3 23.3359375,4.984375 20,10.484375 C16.6640625,4.984375 14.75,3 11.4453125,3 C8.234375,3 5.625,5.8046875 5.625,9.25 C5.625,10.6640625 6.078125,11.953125 6.8203125,13 L3.75,13 C1.6796875,13 0,14.6796875 0,16.75 L0,24.25 C0,24.9375 0.5625,25.5 1.25,25.5 L2.5,25.5 L2.5,34.25 C2.5,36.3203125 4.1796875,38 6.25,38 L33.75,38 C35.8203125,38 37.5,36.3203125 37.5,34.25 L37.5,25.5 L38.75,25.5 C39.4375,25.5 40,24.9375 40,24.25 L40,16.75 C40,14.6796875 38.3203125,13 36.25,13 Z",
    id: "Fill-1",
    fill: "#0CBEB8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlyceGiftLogo);
export default __webpack_public_path__ + "static/media/alyce-gift-logo.b2c1c3fdf4318cd768789443ac37922f.svg";
export { ForwardRef as ReactComponent };